var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getLocalVideoOffClasses},[_vm._v(" Your video is currently turned off. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }